import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BookingDetailsData } from "../../types/booking";


const InvoicePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [booking, setBooking] = useState<BookingDetailsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);

    fetch(`https://uberevisa.com/api/booking/${id}/invoice`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load invoice data");
        return res.json();
      })
      .then((data) => {
        setBooking(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p>Loading invoice...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!booking) return <p>No invoice data found.</p>;

  return (
    <div style={{ maxWidth: 600, margin: "auto", padding: 20, fontFamily: "Arial" }}>
      <h1>Invoice for Booking {booking.bookingCode ?? "N/A"}</h1>
      <p><strong>Customer:</strong> {booking.customerName ?? "N/A"}</p>
      <p><strong>Phone:</strong> {booking.phone ?? "N/A"}</p>
      <p><strong>Email:</strong> {booking.email ?? "N/A"}</p>
      <p><strong>Nationality:</strong> {booking.nationalityName ?? "N/A"}</p>
      <p><strong>Entry Type:</strong> {booking.entryType ?? "N/A"}</p>
      <p><strong>Duration:</strong> {booking.duration ?? "N/A"}</p>
      <p><strong>Booking Date:</strong> {booking.bookingDate ? new Date(booking.bookingDate).toLocaleDateString() : "N/A"}</p>
      <p><strong>Total Price:</strong> AED {booking.totalPrice?.toFixed(2) ?? "0.00"}</p>
      <div style={{ marginTop: 40 }}>
        <em>Thank you for your business!</em>
      </div>
      <footer style={{ marginTop: 20, textAlign: "center", fontSize: 12, color: "#666" }}>
        Generated on {new Date().toLocaleString()}
      </footer>
    </div>
  );
};

export default InvoicePage;
